import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './NotificationsPanel.css';
import imgSuccess from '../../assets/images/icons/success.png';
import imgError from '../../assets/images/icons/error.png';
import imgInfo from '../../assets/images/icons/info.png';
import { useNotificationsContext } from '../../utils/Contexts/NotificationsContext';
import { CDBModal } from 'cdbreact';
import { ModalOpenNotification } from '../../Components/Modals/ModalOpenNotification';
import { toast } from 'react-toastify';
import { Pagination } from 'antd';

export const NotificationsPanel = () => {
  const ntfs = useNotificationsContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [notifications, setNotifications] = useState(ntfs.notifications);
  const [open, setOpen] = useState({ modal1: false });
  const [selectedNotification, setSelectedNotification] = useState(null);

  useEffect(() => {
    const notificationObserver = (notifications) => {
      setNotifications(notifications);
    };
    ntfs.addObserver('notifications', notificationObserver);
    return () => {
      ntfs.removeObserver('notifications', notificationObserver);
    };
  }, [ntfs]);

  useEffect(() => {
    ntfs.loadNotifications(page, pageSize);
  }, [page, pageSize, ntfs]);

  const calculateTimeAgo = (date) => {
    const now = moment();
    const notificationDate = moment(date);
    const minutesAgo = now.diff(notificationDate, 'minutes');
    if (minutesAgo < 1) {
      return 'hace un momento';
    } else if (minutesAgo < 60) {
      return `hace ${minutesAgo} minutos`;
    } else {
      const hoursAgo = now.diff(notificationDate, 'hours');
      if (hoursAgo < 24) {
        return `hace ${hoursAgo} horas`;
      } else {
        const daysAgo = now.diff(notificationDate, 'days');
        if (daysAgo < 7) {
          return `hace ${daysAgo} días`;
        } else {
          const weeksAgo = now.diff(notificationDate, 'weeks');
          return `hace ${weeksAgo} semanas`;
        }
      }
    }
  };

  const openNotification = (notification) => {
    setSelectedNotification(notification);
    ntfs.markNotificationRead(notification.id);
    toggle(1)();
  };

  const toggle = (nr) => () => {
    let modalNumber = 'modal' + nr;
    setOpen({
      ...open,
      [modalNumber]: !open[modalNumber],
    });
  };

  const onChangePagination = (newPage, pageSize) => {
    setPage(newPage); 
    setPageSize(pageSize);
  };

  return (
    <>
      <div className='card card-panel w-100 border p-4'>
        <div className='card-header'>
          &nbsp;
          <div className="d-flex">
            <div className='p-1 bg-grey rounded-circle'>
              <i className='fa fa-bell'></i>
            </div>
            &nbsp;&nbsp;
            <h4 className='font-weight-bold text-dark h4 dropdown-toolbar-title'>Notificaciones</h4>
          </div>
          <div className="subtitle">
            <span>Total: {ntfs.getNumberTotalNotifications()}</span>
            &nbsp;&nbsp;
            <span>Sin leer: {ntfs.getNumberUnseenNotifications()}</span>
          </div>
        </div>

        <div className="card-body pt-4">
          {ntfs.getNumberTotalNotifications() === 0 ? (
            <div className="text-center">
              Sin Notificaciones
            </div>
          ) : (
            <>
              {ntfs.notifications.slice().map((notification) => (
                <div 
                  id={notification.id} 
                  key={notification.id}
                  className={`notification-item ${!ntfs.viewedNotifications.includes(notification.id) ? 'unread' : ''}`} 
                  onClick={() => openNotification(notification)}
                >
                  <div className="notification-item-content">
                    <div className="notification-item-img">
                      <img src={notification.type === 'info' ? imgInfo : notification.type === 'error' ? imgError : imgSuccess} alt="type"></img>
                    </div>
                    <div className="notification-item-detail">
                      <strong>{notification.title}</strong>
                      <p className="text-muted">{ntfs.truncatedMessage(notification.message, 80)}</p>
                      <p className="text-muted"><small>{calculateTimeAgo(notification.date)}</small></p>
                    </div>
                  </div>
                </div>
              ))}
              <div className="d-flex justify-content-center mt-4">
                <Pagination
                  showSizeChanger
                  showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} notificaciones`}
                  current={page}
                  defaultPageSize={pageSize}
                  onChange={onChangePagination}
                  total={ntfs.pagination.totalItems}
                />
              </div>
            </>
          )}
        </div>
      </div >
      <CDBModal isOpen={open.modal1} toggle={toggle(1)}>
        <ModalOpenNotification
          selectedNotification={selectedNotification}
          closeModal={toggle(1)}
        />
      </CDBModal>
    </>
  );
};